/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import Text from 'components/Text';
import { MEDIA_QUERIES } from 'styles/constants';
import AppStore from 'assets/images/AppStore.svg';
import { BLACK, PURPLE_FEEK } from 'styles/colors';
import GooglePlay from 'assets/images/GooglePlay.svg';

const styles = css`
  .feek-stores-purple {
    font-weight: 700;
    color: ${PURPLE_FEEK};
  }

  .feek-store-row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .feek-store-center {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 60px;
  }

  .feek-store-logo {
    padding: 15px 30px;
  }

  .title {
    color: var(--ui-20-black-out, #000);
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 84px */
  }

  .feek-stores-text {
    leading-trim: both;
    text-edge: cap;
    font-size: 32px;
    font-family: Roobert;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 44.8px */
  }

  ${MEDIA_QUERIES.mobile} {
    .feek-stores-title {
      font-size: 32px;
    }

    .feek-stores-text {
      font-size: 28px;
    }
  }
`;

/**
 * FeekStores component - displays download links for Feek app
 * Shows app store badges for iOS and Android with call-to-action text
 */
export const FeekStores = () => {
  return (
    <div id="feek-stores" css={styles}>
      <Text
        color={BLACK}
        fontSize={60}
        align="center"
        className="feek-stores-title mb-5"
      >
        Live it, share it,{' '}
        <span className="feek-stores-purple">Feek</span> it!
      </Text>
      <div className="row">
        <div className="col-md-10 col-lg-8 offset-md-1 offset-lg-2 px-4 feek-stores-text mb-5">
          <Text
            color={BLACK}
            align="center"
            className="feek-stores-text"
          >
            Colaborar y gozar de increíbles beneficios nunca había
            sido tan accesible y fácil. ¡Descárgala ya!
          </Text>
        </div>
      </div>

      <div className="feek-store-row feek-store-center mt-2">
        <a
          href="https://qrco.de/be4ftN"
          target="_blank"
          rel="noreferrer"
          className="mx-2"
          aria-label="Download Feek on App Store"
        >
          <img
            src={AppStore}
            alt="Download Feek on App Store"
            className="feek-store-logo border-radius-25 img-fluid"
            width={300}
            height={90}
            loading="lazy"
          />
        </a>
        <a
          href="https://qrco.de/be57iC"
          target="_blank"
          className="mx-2"
          rel="noreferrer"
          aria-label="Download Feek on Google Play"
        >
          <img
            src={GooglePlay}
            alt="Download Feek on Google Play"
            className="feek-store-logo border-radius-25 img-fluid"
            width={300}
            height={90}
            loading="lazy"
          />
        </a>
      </div>
    </div>
  );
};
